import {
  useQueryClient,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";

import { API_DELETE_FACTOR_URL } from "constants/apiUrls";

import { QueryKey } from "types/queryKey/queryKey";

import useGetApiClient from "./useGetApiClient";

export type DeleteFactorData = {
  factorId: string;
};

function useDeleteFactor(): UseMutationResult<
  unknown,
  unknown,
  DeleteFactorData
> {
  const apiClient = useGetApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      const response = await apiClient(API_DELETE_FACTOR_URL, {
        method: "DELETE",
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        return Promise.reject(await response.json());
      } else {
        return await queryClient.fetchQuery([QueryKey.AllFactors]);
      }
    },
    onError: (error) => {
      console.log("Error!!!!!");
      console.log(error);
    },
  });
}

export default useDeleteFactor;
